export default __webpack_public_path__ + "static/media/as-1.cf3ddea5.jpg";